import { Route, Routes, useParams } from 'react-router-dom'
import PersonDetailsEditPage from './PersonDetailsEditPage'
import PersonDetailsPage from './PersonDetailsPage'
import PersonPage from './PersonPage'

const PersonDetailRouter = () => {
  const { id } = useParams()

  return (
    <Routes>
      <Route path="edit" element={<PersonDetailsEditPage id={id!} />} />
      <Route path="" element={<PersonDetailsPage id={id!} />} />
    </Routes>
  )
}

const PersonRouter = () => {
  return (
    <Routes>
      <Route path=":id/*" element={<PersonDetailRouter />} />
      <Route path="" element={<PersonPage />} />
    </Routes>
  )
}

export default PersonRouter
